var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9 2H9.1c-.68 0-1.64.4-2.12.88l-4.1 4.1C2.4 7.46 2 8.42 2 9.1v5.8c0 .68.4 1.64.88 2.12l1.53 1.53L18.55 4.41l-1.53-1.53C16.54 2.4 15.58 2 14.9 2zM19.61 5.469 5.47 19.609l1.51 1.51c.48.48 1.44.88 2.12.88h5.8c.68 0 1.64-.4 2.12-.88l4.1-4.1c.48-.48.88-1.44.88-2.12v-5.8c0-.68-.4-1.64-.88-2.12l-1.51-1.51zM2.49 21.53c.15.15.34.22.53.22s.38-.07.53-.22l1.92-1.92-1.06-1.06-1.92 1.92c-.29.29-.29.77 0 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.53 2.49a.754.754 0 0 0-1.06 0l-1.92 1.92 1.06 1.06 1.92-1.92c.29-.29.29-.77 0-1.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldForbidden);
export default __webpack_public_path__ + "static/media/vuesax-bold-forbidden.f3bce5c14428076720e100cebb0dcbcd.svg";
export { ForwardRef as ReactComponent };